<input type="text"
  class="input"
  data-test="capra-search-input-field"
  [class.input-error]="error"
  #input
  [capraAutofocus]="autofocus"
  [disabled]="disabled"
  [placeholder]="placeholder"
  [ngModel]="text"
  (ngModelChange)="textChange.emit($event)"
/>
<mode-capra-icon
  class="icon"
  data-test="capra-search-input-icon"
  [class.icon-clickable]="icon === 'icon-close'"
  [class.icon-disabled]="disabled"
  [icon]="icon"
  (click)="onIconClick()"
></mode-capra-icon>
